import Loadable from 'react-loadable';
import Loading from '../components/Loading'

const Home = Loadable({ loader: () => import('../views/home'), loading: Loading });
const Reserve = Loadable({ loader: () => import('../views/reserve'), loading: Loading });
const Promotions = Loadable({ loader: () => import('../views/promotions'), loading: Loading });
const Bookings = Loadable({ loader: () => import('../views/bookings'), loading: Loading });
const Result = Loadable({ loader: () => import('../views/result'), loading: Loading });


const Product = Loadable({ loader: () => import('../views/product'), loading: Loading });
const InputForm = Loadable({ loader: () => import('../views/input'), loading: Loading });
const Profile = Loadable({ loader: () => import('../views/profile'), loading: Loading });
const Login = Loadable({ loader: () => import('../views/login'), loading: Loading });
const Preview = Loadable({ loader: () => import('../views/preview'), loading: Loading });
const WechatLogin = Loadable({ loader: () => import('../views/login/WechatLogin'), loading: Loading });
const Authorize = Loadable({ loader: () => import('../views/login/Authorize'), loading: Loading });
const ConfirmForm = Loadable({ loader: () => import('../views/confirm'), loading: Loading });
const BindAccount = Loadable({ loader: () => import('../views/login/BindAccount'), loading: Loading });
const ChatBox = Loadable({ loader: () => import('../views/chatbox'), loading: Loading });


const arr = [
    { path: '/home', component: Home, cacheFlag: true },
    { path: '/promotions', component: Promotions },
    { path: '/reserve', component: Reserve },
    { path: '/bookings', component: Bookings },
    { path: '/result', component: Result },

    { path: '/product', component: Product },
    { path: '/input', component: InputForm },
    { path: '/profile', component: Profile },
    { path: '/login', component: Login },
    { path: '/preview', component: Preview },
    { path: '/wechatlogin', component: WechatLogin },
    { path: '/authorize', component: Authorize },
    { path: '/confirm', component: ConfirmForm },
    { path: '/bind', component: BindAccount },
    { path: '/chatbox', component: ChatBox },
]

export default arr